'use client'

import { Info } from 'lucide-react'
import * as React from 'react'

import { cn } from '../cn'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './tooltip'

/**
 * An (i) that explains the thing beside it. A plain tooltip opens only on hover
 * or focus, so on a phone it never opens; this one also toggles on tap.
 */
function InfoHint({
  label,
  children,
  className,
}: {
  /** What the button is for, read by screen readers ("How Net Volume is calculated"). */
  label: string
  children: React.ReactNode
  className?: string
}) {
  const [open, setOpen] = React.useState(false)
  return (
    <TooltipProvider>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={label}
            onClick={() => setOpen(o => !o)}
            className={cn(
              'inline-flex size-8 shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none',
              className,
            )}
          >
            <Info className="size-4" aria-hidden />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs text-left leading-relaxed">
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export { InfoHint }
